import { createApp } from "vue";
import { postsData } from "../../util/postsData";
import { fetchWpApi } from "../../common/functions/fetchWpApi.es6";
import Mv from "../../components/Mv.vue";
import PlayVideo from "../../components/PlayVideo.vue";
import News from "../../components/News.vue";
import Movie from "../../components/Movie.vue";
import Character from "../../components/Character.vue";
import Story from "../../components/Story.vue";
import Item from "../../components/Item.vue";
import Bluray from "../../components/Bluray.vue";

export async function initializeVue() {
    const [news, movie, character, story, bluray] = await Promise.all([
        fetchWpApi("news", "_fields=title,date,link&orderby=date&order=desc&per_page=4"),
        fetchWpApi("movie", "_fields=acf&acf_format=standard&orderby=date&order=desc&per_page=100"),
        fetchWpApi("character", "_fields=slug,acf,title&acf_format=standard&orderby=date&order=asc&per_page=100"),
        fetchWpApi("story", "_fields=acf,title&acf_format=standard&orderby=date&order=asc&per_page=100"),
        fetchWpApi("bluray", "_fields=acf,link,thumbnail_url&acf_format=standard&orderby=date&order=asc&per_page=100"),
        fetchWpApi("special", "_fields=thumbnail_url,link&orderby=date&order=asc&per_page=100"),
    ]);

    postsData.news = news;
    postsData.movie = movie;
    postsData.character = character;
    postsData.story = story;
    postsData.bluray = bluray;

    createApp(Mv, { datas: postsData.mvSlider }).mount("#mvSlider");
    createApp(PlayVideo, { id: movie[0].acf.id, classNames: ["mv__video", "-smallest"] }).mount("#mv-video");
    createApp(News).mount("#news");
    createApp(Movie).mount("#movie");
    createApp(Character).mount("#character");
    createApp(Story).mount("#story");
    createApp(Item, { datas: postsData.music }).mount("#music");
    createApp(Bluray, { datas: postsData.bluray }).mount("#bluray");
}
